import { render, staticRenderFns } from "./customer.vue?vue&type=template&id=4cb6a8f3&scoped=true&"
import script from "./customer.vue?vue&type=script&lang=js&"
export * from "./customer.vue?vue&type=script&lang=js&"
import style0 from "./customer.vue?vue&type=style&index=0&id=4cb6a8f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb6a8f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
